/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoFileReader implements angular.IDirective {
        restrict = "A";

        scope = {
            meevoFileReader: '=',
            onUpload: '&?'
        }

        constructor() {
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            element.bind("change", function (e) {
                var reader = new FileReader();
                reader.onload = function (loadEvent) {
                    scope.$apply(function () {
                        scope.meevoFileReader = (<any>loadEvent.target).result;

                        if (typeof scope.onUpload === 'function') {
                            scope.onUpload();
                        }
                    });
                }
                reader.readAsText((<any>e.target).files[0]);
            });
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoFileReader();
            }
                //directive.$inject = [];
                return directive;
            }
        }

    angular.module("meevo.components.controls")
        .directive("meevoFileReader", MeevoFileReader.factory());
}
